import * as MutationTypes from './mutationTypes';
import * as api from './api';
import { Feature, Tag } from './models';
import { getAllPages } from "@core/helpers";

export const masterFeatureListRequest = async ({ commit, getters: { masterFeatureList } }) => {
  if (masterFeatureList.length === 0) {
    const response = await api.getMasterFeatureListRequest();
    const results = await getAllPages(response);
    const features = Feature.toInstanceList(results);
    commit(MutationTypes.MASTER_FEATURE_LIST_SUCCESS, features);
  }
};

export const masterTagsListRequest = async ({ commit, getters: { masterTagList } }) => {
  if (masterTagList.length === 0) {
    const response = await api.getMasterTagsListRequest();
    const results = await getAllPages(response);
    const tags = Tag.toInstanceList(results);
    commit(MutationTypes.MASTER_TAG_LIST_SUCCESS, tags);
  }
};
